module.exports = __webpack_public_path__ + "img/no-pic.cfa225c0.jpg";